/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';

@Injectable()
export class ThemeService {
  use(name: string): void {
    const list = document.body.classList;
    // remove current theme
    for (let i = 0; i < list.length; i++) {
      const className = list.item(i)!; // tslint:disable-line:no-non-null-assertion
      if (/mat-theme$/.test(className)) {
        list.remove(className);
        i--;
      }
    }

    // assign new theme
    list.add(`${name}-mat-theme`);
  }

  load(name: string): Promise<void> {
    return import(`@gh/theme/styles/theme-${name}.scss`);
  }
}
